import { Box, Button, TextField, Typography, Chip, Stack } from '@mui/material'
import Title from 'components/title/Title'
import BenchmarkReportGenerator from 'containers/benchmark/benchmarkReportGenerator/BenchmarkReportGenerator'
import { useState } from 'react'
import { useNavigate } from 'react-router'

export default function BenchmarkIpcrCodesPage() {
  const [input, setInput] = useState('')
  const [codes, setCodes] = useState<string[]>([])

  const navigate = useNavigate()

  const parseCodes = (text: string) => {
    return text
      .split(/[\s,;\n]+/) // separa por espacios, comas o saltos de línea
      .map(c => c.trim())
      .filter(Boolean)
  }

  const handleAddCodes = () => {
    const newCodes = parseCodes(input)

    const merged = [...codes, ...newCodes]
    const unique = Array.from(new Set(merged)) // Remove duplicados

    setCodes(unique)
    setInput('')
  }

  const handleDelete = (code: string) => {
    setCodes(prev => prev.filter(c => c !== code))
  }

  return (
    <Box
      sx={{
        display: 'block',
        textAlign: 'left',
        maxWidth: '887px',
        margin: '89px auto 0 auto',
        padding: '0 20px',
      }}>
      <Title variant="h4" sx={{ pb: '33px' }}>
        Create Benchmark with custom IPCR Codes
      </Title>

      <TextField
        fullWidth
        multiline
        minRows={3}
        label="Paste or type IPCR codes"
        value={input}
        onChange={e => setInput(e.target.value)}
        placeholder={`Example:
G01N1/34
B01L3/00
G10L15/22`}
      />

      <Button variant="outlined" sx={{ mt: 2 }} onClick={handleAddCodes} disabled={!input.trim()}>
        Add IPCR Codes
      </Button>

      {codes.length > 0 && (
        <Box mt={3}>
          <Typography mb={1}>Selected IPCR Codes</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap">
            {codes.map(code => (
              <Chip key={code} label={code} onDelete={() => handleDelete(code)} />
            ))}
          </Stack>
        </Box>
      )}
      <Box mt={4}></Box>
      <BenchmarkReportGenerator
        id=""
        name="Benchmark Report with custom IPCR Codes"
        ipcrCodes={codes}
        origin="custom"
        onCreated={benchmarkId => navigate(`/dashboard/reporting/benchmark/${benchmarkId}`)}
      />
    </Box>
  )
}
